import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { GoogleLogin } from "react-google-login";
import { useSelector } from "react-redux";
import {
  Button,
  LoadingIndicator,
  Select
} from "../../../../components/simple";

import { PLATFORMS } from "../platforms";
import Api from "../../../../api";

import styles from "../push-modal.module.scss";
import LabelForRow from "../../../../components/forms/LabelForRow";

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

// eslint-disable-next-line react/prefer-stateless-function
const GoogleAds = ({
  // audienceType,
  // editAudienceHandler,
  selectedPlatform,
  // customerId,
  // campaignId,
  handlePushToPlatform
  // allowEdit
  // handleGoogleAdsFieldsChange,
}) => {
  const [googleAdsIsAuthorized, setGoogleAdsIsAuthorized] = useState(false);

  const [selectedData, setSelectedData] = useState({
    customerId: "",
    campaignId: ""
  });

  const [responseData, setResponseData] = useState({
    customers: [],
    campaigns: []
  });

  const [responseErrorMessage, setResponseErrorMessage] = useState({
    customers: "",
    campaigns: ""
  });

  const prevSelectedData = usePrevious(selectedData);

  const platforms = useSelector(state => state.platforms);

  // const handleInputChange = (name, value) => {
  //   handleGoogleAdsFieldsChange(name, value);
  // };

  useEffect(() => {
    const checkGoogleIsAuthorized = async () => {
      await Api.platforms.googleAds
        .isAuthorized()
        .then(res => {
          if (res?.valid) {
            setGoogleAdsIsAuthorized(true);
          } else {
            setGoogleAdsIsAuthorized(false);
          }
        })
        .catch(error => {
          console.log(error);
          setGoogleAdsIsAuthorized(false);
        });
    };

    checkGoogleIsAuthorized();
  }, []);

  useEffect(() => {
    if (!googleAdsIsAuthorized || responseErrorMessage.customers) return;

    const getCustomers = async () => {
      // setResponseErrorMessage((prevState) => ({
      //   ...prevState,
      //   customers: "",
      // }));

      try {
        const customers = await Api.platforms.googleAds.getCustomers();

        if (customers.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            customers: customers.message
          }));

          setResponseData({
            customers: [],
            campaigns: []
          });

          return;
        }

        setResponseData({
          customers,
          campaigns: []
        });
      } catch (error) {
        console.log(error);
      }
    };

    const getCampaigns = async customerId => {
      setSelectedData(prevData => ({
        ...prevData,
        campaignId: ""
      }));

      setResponseErrorMessage(prevState => ({
        ...prevState,
        campaigns: ""
      }));

      try {
        const campaigns = await Api.platforms.googleAds.getCampaigns({
          customerId
        });

        if (campaigns.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            campaigns: campaigns.message
          }));

          setResponseData(prevData => ({
            ...prevData,
            campaigns: []
          }));

          return;
        }

        setResponseData(prevData => ({
          ...prevData,
          campaigns
        }));
      } catch (error) {
        console.log(error);
      }
    };

    if (!responseData.customers.length) getCustomers();

    if (
      prevSelectedData.customerId !== selectedData.customerId &&
      selectedData.customerId
    ) {
      getCampaigns(selectedData.customerId);
    }
  }, [
    googleAdsIsAuthorized,
    selectedData,
    responseData,
    prevSelectedData,
    responseErrorMessage
  ]);

  const responseGoogle = async response => {
    await Api.platforms.googleAds
      .setRefreshToken({ data: response })
      .then(() => setGoogleAdsIsAuthorized(true));
  };

  const handleSelectChange = (name, value) => {
    setSelectedData(prevData => ({
      ...prevData,
      [`${name}Id`]: value
    }));
  };

  const onSubmitHandler = e => {
    e.preventDefault();

    if (selectedData.customerId && selectedData.campaignId)
      handlePushToPlatform(PLATFORMS.googleAds, {
        customerId: selectedData.customerId,
        campaignId: selectedData.campaignId
      });
  };

  // const handleInputChange = (name, value) => {
  //   setSelectedData((prevState) => ({
  //     ...prevState,
  //     [`${name}Id`]: value,
  //   }));
  // };

  return (
    <>
      <div
        className={` ${styles["googleAds-signin"]} ${
          selectedPlatform === "googleAds" ? styles["slide-from-right"] : ""
        }`}
      >
        {/* <div className={styles["platform-logo"]}> */}
        {/*  <SVG.GoogleAds width={40} height={40} /> GoogleAds */}
        {/* </div> */}

        {googleAdsIsAuthorized ? (
          <>
            <div className={styles["connect-account"]}>
              {/* Provide the necessary data */}
              <form onSubmit={onSubmitHandler}>
                {!responseErrorMessage.customers ? (
                  <div>
                    <LabelForRow
                      label="Choose the organization"
                      title="Pick Organization"
                    />
                    <Select
                      value={
                        selectedData.customerId
                          ? {
                              label: "customer",
                              value: selectedData.customerId
                            }
                          : ""
                      }
                      selectForThePushForm
                      className="push-platform"
                      isSearchable
                      label="Customer"
                      placeholder="Customer"
                      optionLabel="name"
                      optionValue="id"
                      options={responseData.customers}
                      name="customer"
                      handleChange={handleSelectChange}
                      required
                    />
                  </div>
                ) : (
                  <p
                    className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                  >
                    {responseErrorMessage.customers}
                  </p>

                  // <Input
                  //   type="text"
                  //   value={selectedData.customerId}
                  //   label="Customer"
                  //   name="customer"
                  //   placeholder="Customer"
                  //   handleChange={handleInputChange}
                  //   required
                  //   // fieldError={
                  //   //   fieldErrors.name || "Please, provide a valid name"
                  //   // }
                  // />
                )}

                {/* {!responseErrorMessage.campaigns ? ( */}
                {!responseErrorMessage.campaigns &&
                !responseErrorMessage.customers ? (
                  <div>
                    <LabelForRow
                      label="Choose the campaign the audience needs to be added to"
                      title="Pick Campaign"
                    />
                    <Select
                      value={
                        selectedData.campaignId
                          ? {
                              label: "adAccount",
                              value: selectedData.campaignId
                            }
                          : ""
                      }
                      isSearchable
                      selectForThePushForm
                      label="Campaign"
                      placeholder="Campaign"
                      optionLabel="name"
                      optionValue="id"
                      options={responseData.campaigns}
                      name="campaign"
                      handleChange={handleSelectChange}
                      isDisabled={!responseData.campaigns.length}
                      required
                    />
                  </div>
                ) : (
                  <p
                    className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                  >
                    {responseErrorMessage.campaigns}
                  </p>

                  // <Input
                  //   type="text"
                  //   value={selectedData.campaignId}
                  //   label="Campaign"
                  //   name="campaign"
                  //   placeholder="Campaign"
                  //   handleChange={handleInputChange}
                  //   required
                  // />
                )}

                {platforms?.isLoading ? (
                  <div
                    style={{ marginTop: "32px" }}
                    className="mt-4 d-flex justify-content-center"
                  >
                    <LoadingIndicator />
                  </div>
                ) : (
                  <div className="mt-5">
                    <Button
                      disabled={
                        !selectedData.customerId || !selectedData.campaignId
                      }
                      type="submit"
                      className={styles["push-audience-btn"]}
                    >
                      <span>Push</span>
                    </Button>
                    {/* {audienceType === "audience" && allowEdit && ( */}
                    {/*  <Button */}
                    {/*    type="button" */}
                    {/*    className={`btn btn-secondary ${styles["edit-audience-btn"]}`} */}
                    {/*    onClick={editAudienceHandler} */}
                    {/*  > */}
                    {/*    <span>Edit audience</span> */}
                    {/*  </Button> */}
                    {/* )} */}
                  </div>
                )}
              </form>
            </div>
          </>
        ) : (
          <>
            <div className={styles["connect-account"]}>Connect Account</div>

            <GoogleLogin
              clientId={process.env.REACT_APP_GOOGLE_ADS_APP_CLIENT_ID}
              render={renderProps => (
                <button
                  type="button"
                  className={styles["platform-signin-button"]}
                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                >
                  Sign in to Google
                </button>
              )}
              onSuccess={responseGoogle}
              onFailure={responseGoogle}
              cookiePolicy="single_host_origin"
              scope="https://www.googleapis.com/auth/adwords"
              accessType="offline"
              responseType="code"
              prompt="consent"
            />
          </>
        )}
        <div className={styles["platform-description"]}></div>
      </div>
    </>
  );
};

GoogleAds.propTypes = {
  // audienceType: PropTypes.string.isRequired,
  // editAudienceHandler: PropTypes.func.isRequired,
  selectedPlatform: PropTypes.string,
  handlePushToPlatform: PropTypes.func
  // allowEdit: PropTypes.bool.isRequired
};

GoogleAds.defaultProps = {
  selectedPlatform: "",
  handlePushToPlatform: () => {}
};

export default GoogleAds;
